import { NonComplianceShipmentStatus } from "@deliverr/commons-clients";

export const NC_SHIPMENT_STATUS_DISPLAY_TEXT = {
  [NonComplianceShipmentStatus.ACTION_NEEDED]: "Action Needed",
};
